/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_Price_PcInputs */

const en_pc_cmp_r_price_pc = /** @type {(inputs: Pc_Cmp_R_Price_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free, forever`)
};

const zh_pc_cmp_r_price_pc = /** @type {(inputs: Pc_Cmp_R_Price_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`永久免费`)
};

/**
* | output |
* | --- |
* | "Free, forever" |
*
* @param {Pc_Cmp_R_Price_PcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_price_pc = /** @type {((inputs?: Pc_Cmp_R_Price_PcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_Price_PcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_price_pc(inputs)
	return zh_pc_cmp_r_price_pc(inputs)
});
export { pc_cmp_r_price_pc as "pc.cmp.r.price.pc" }